import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-empty-all-hidden',
  imports: [TranslatePipe],
  templateUrl: './dashboard-empty-all-hidden.component.html',
  styleUrl: './dashboard-empty.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardEmptyAllHiddenComponent {}
